export default __webpack_public_path__ + "static/media/P350_CoC.9c9b34ca.pdf";